<!--
    Panel zmiany języka
-->

<i18n>
    {
    "en": {
    "language": "language"
    },
    "fr": {
    "language": "langue"
    },
    "pl": {
    "language": "język"
    },
    "de": {
    "language": "sprache"
    }
    }
</i18n>

<template>
    <div class="LocalePanel">
        <span>{{ $t('language') }}: &nbsp;</span>
        <button @click="locale = 'en'" :disabled="isActive('en')">EN</button>
        <button @click="locale = 'fr'" :disabled="isActive('fr')">FR</button>
        <button @click="locale = 'pl'" :disabled="isActive('pl')">PL</button>
        <button @click="locale = 'de'" :disabled="isActive('de')">DE</button>
    </div>
</template>

<script>
    export default {
        name: 'LocalePanel',

        data() {
            this.$i18n.locale = this.$root.$i18n.locale = this.$route.query.lang || 'fr';
            return {
                locale: 'fr'
            }
        },
        mounted: function () {
            //console.log("LOCALE: " + this.$root.$i18n.locale);
            //console.log("LANG: " + this.$route.query.lang);
            //this.locale = this.$route.query.lang || 'en';
        },
        methods: {
            isActive: function (val) {
                return (this.$i18n.locale == val)
            }
        },
        watch: {
            locale(val) {
                this.$i18n.locale = val
                this.$root.$i18n.locale = val
                this.$router.push({ query: { lang: val } })
            }
        }
    }
</script>


<style scoped>
    .LocalePanel {
        display: inline-block;
        text-align: right;
        position: absolute;
        bottom: 10px;
        right: 15px;
    }

    span {
        text-transform: capitalize;
    }

    button {
        background-size: cover;
        background-color: transparent;
        border: none;
        outline: none;
        cursor: pointer;
        padding: 5px;
        /*box-shadow: inset -1px 1px 1px 0px rgba(0,0,0,0.5);*/
        box-sizing: border-box;
        transition: all 0.3s ease;
        color: #777;
        /*border-bottom: 0px solid rgba(255,255,255,0);*/
        /*opacity: 1;*/
        font-size: 21px;
    }

        button:disabled,
        button[disabled] {
            color: #FFF;
            /*box-shadow: inset 0 0 14px 0px rgba(0, 0, 0, 0.5);*/
            /*border-bottom: 1px solid rgba(255,255,255,1);*/
            /*opacity: 0.5;*/
        }
</style>